import { Component, input, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'andor-fieldset',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fieldset.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './fieldset.scss',
})
export class Fieldset {
  headline = input('');
  size = input<'fill' | 'fit'>('fit');
  direction = input<'center' | ''>('');
  /**
   * Bounds the fieldset to its host's height and scrolls the content area
   * inside the frame (headline stays fixed) instead of growing past it.
   * Requires the host element to have a definite height (e.g. a flex slot).
   */
  scroll = input(false);
}
